import Layout from "@/admin/js/layout/index.vue";

const telegramBotMessagesRoutes = {
    name: 'telegram-notifications',
    path: '/telegram-notifications',
    component: Layout,
    meta: { title: 'Телеграм уведомления', noCache: false },
    redirect: '/telegram-notifications/list',
    children: [
        {
            name: 'telegram-notifications-list',
            path: 'list',
            component: () => import('@/admin/js/views/telegrambot-messages/index.vue'),
            meta: { 
                title: 'Список уведомлений', 
                permissions: ['manage_users'] // Требуемые права
            }
        },
    ]
};

export default telegramBotMessagesRoutes;